interface CurrencyFormatterProps {
  value: number | undefined;
  currency: string | undefined;
  locale: string;
  showSign: boolean;
  disableDecimals: boolean;
  fractions: number;
}

export const currencyFormatter = ({
  value,
  currency,
  locale,
  showSign,
  disableDecimals,
  fractions,
}: CurrencyFormatterProps) => {
  // If the value is a string, return it as is
  if (typeof value === "string") {
    return value;
  }
  if (value === undefined) {
    return "";
  }
  if (!currency) {
    return value.toString();
  }
  const currencyFormat = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency?.toUpperCase(),
    minimumFractionDigits: disableDecimals ? 0 : fractions,
    maximumFractionDigits: disableDecimals ? 0 : fractions,
    currencyDisplay: !showSign ? "code" : undefined,
  });

  return showSign
    ? currencyFormat.format(value)
    : currencyFormat.format(value).replace(currency ?? "", "");
};
